export const priceHelper = (price: string | number | undefined): string => {
    return (price || 0).toLocaleString(
        "fi-FI",
        {
            style: "currency",
            currency: "EUR",
        }
    )
}
